import { Box, Stack, Text } from 'braid-design-system';
import type { FC } from 'react';

import { VerifiedBySeekPassIcon } from '../../../VerifiedBySeekPassIcon';

import * as styles from './styles.css';

interface ProfileDetailsProps {
  details: Array<{
    name: string;
    values: string[];
    showVerifiedIcon?: boolean;
  }>;
}

export const ProfileDetails: FC<ProfileDetailsProps> = ({ details }) => {
  const { nonEmptyNameValues, emptyNameValues } = details.reduce<{
    emptyNameValues: string[];
    nonEmptyNameValues: Array<{
      name: string;
      values: string[];
      showVerifiedIcon?: boolean;
    }>;
  }>(
    (acc, current) => {
      if (current.name) {
        acc.nonEmptyNameValues.push(current);
      } else {
        acc.emptyNameValues.push(current.values.join(', '));
      }

      return acc;
    },
    { emptyNameValues: [], nonEmptyNameValues: [] },
  );

  const detailedList = (
    <Box component="dl" className={styles.detailList}>
      {nonEmptyNameValues.map(({ name, values, showVerifiedIcon }, i) => (
        <Box
          component="div"
          key={i}
          className={styles.descriptionTermDetailsGroup}
        >
          <Box
            component="dt"
            name={name}
            className={styles.column1}
            paddingRight="medium"
          >
            <Text
              size="small"
              tone="secondary"
              data={{
                'hj-masked': true,
              }}
            >
              {name}
            </Text>
          </Box>
          <Box component="dd" className={styles.column2}>
            {values.length === 1 ? (
              <Text
                size="small"
                data={{
                  'hj-masked': true,
                }}
              >
                {values[0]}
              </Text>
            ) : (
              <Stack space="small" component="ul">
                {values.map((value, index) => (
                  <Text
                    key={index}
                    component="li"
                    size="small"
                    data={{
                      'hj-masked': true,
                    }}
                  >
                    {value}
                  </Text>
                ))}
              </Stack>
            )}
            {showVerifiedIcon ? (
              <VerifiedBySeekPassIcon
                id={`${name}-${values.join('-')}`}
                title=""
              />
            ) : null}
          </Box>
        </Box>
      ))}
    </Box>
  );

  if (emptyNameValues.length > 0) {
    return (
      <Stack space={['medium', 'small']}>
        {emptyNameValues.map((values, index) => (
          <Text key={index} size="small">
            {values}
          </Text>
        ))}
        {detailedList}
      </Stack>
    );
  }

  return detailedList;
};
